import { Button } from "@/ui/button";
import { button, dangerTheme } from "@/ui/utils.css";
import { DialogDismiss, DialogStore, useDialogContext } from "@ariakit/react";
import { ReactNode } from "react";
import { ModalDialog } from "../modal-dialog";
import * as css from "./style.css";

export function ConfirmDialog(props: {
  heading: string;
  message: ReactNode;
  submit: string;
  submitTheme?: Record<string, string>;
  onSubmit: () => Promise<void>;
  store?: DialogStore;
}) {
  const contextStore = useDialogContext();
  const store = props.store ?? contextStore;

  return (
    <ModalDialog store={store} className={css.dialog}>
      <form
        className={css.form}
        onSubmit={async (event) => {
          event.preventDefault();

          try {
            await props.onSubmit();
            store?.hide();
          } catch (error) {
            console.error(error);
          }
        }}
      >
        <h1 className={css.heading}>{props.heading}</h1>
        <p className={css.message}>{props.message}</p>

        <div className={css.buttons}>
          <DialogDismiss className={button}>Cancel</DialogDismiss>

          <Button className={button} style={props.submitTheme ?? dangerTheme} type="submit">
            {props.submit}
          </Button>
        </div>
      </form>
    </ModalDialog>
  );
}
